import { HoldingsDto } from '@/models/suba/holdings/HoldingsDto.model';
import { HoldingsGetRequest } from '@/models/suba/holdings/HoldingsGetRequest.model';
import ApiService from '@/services/Api.service';

export class HoldingsService {
  static async get(params: HoldingsGetRequest) {
    return ApiService.getJson<HoldingsDto>('/holdings', params);
  }
}
